export const CompetitiveLevels: { [index: number]: string } = {
  0: "None",
  1: "Fun",
  2: "Casual",
  3: "Sporting",
  4: "Competitive",
  5: "Intense"
};